import React, { useEffect, useState } from "react"
import { Spinner } from "reactstrap"
export default function ComingSoon() {
  return (
    <React.Fragment>
      <div className="page-content m-3">
        <div className="container-fluid d-flex justify-content-center align-items-center min-vh-100 bg-dark text-white">
          <div className="text-center">
            <h1 className="display-3 mb-3">We're Launching Soon!</h1>
            <p className="lead mb-4">
              We're working hard to bring something amazing. Stay tuned!
            </p>

            <div className="row justify-content-center mb-4">
              <div className="col-auto">
                <div className="d-flex justify-content-center">
                  <div className="p-3">
                    <div className="h1">00</div>
                    <div className="small text-uppercase">Days</div>
                  </div>
                  <div className="p-3">
                    <div className="h1">00</div>
                    <div className="small text-uppercase">Hours</div>
                  </div>
                  <div className="p-3">
                    <div className="h1">00</div>
                    <div className="small text-uppercase">Minutes</div>
                  </div>
                  <div className="p-3">
                    <div className="h1">00</div>
                    <div className="small text-uppercase">Seconds</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}
